module.exports = __webpack_public_path__ + "static/media/atc_ultima_bg.0cf7ae6f.webp";